module.exports = __webpack_public_path__ + "img/inst-7.1938720e.png";